<template>
  <section class="disclaimer">
      <div class="disclaimer__content container">
        <div class="disclaimer__text-container">
          <button v-on:click="disclaimer = !disclaimer">See Disclaimer</button>
          <transition name="slide-fade">
            <p v-show="!disclaimer">
              <b>OFFERING CIRCULAR</b>
              <br><br>
				Please read the Offering Circular here: <a class="external-link" target="_blank" href="GST_offering_circular.pdf">Get Offering Circular</a>
              <br><br>
				THE OFFERING MATERIALS MAY CONTAIN FORWARD-LOOKING STATEMENTS AND INFORMATION RELATING TO, AMONG OTHER THINGS, THE COMPANY, ITS BUSINESS PLAN AND STRATEGY, AND ITS INDUSTRY. THESE FORWARD-LOOKING STATEMENTS ARE BASED ON THE BELIEFS OF, ASSUMPTIONS MADE BY, AND INFORMATION CURRENTLY AVAILABLE TO THE COMPANY’S MANAGEMENT. WHEN USED IN THE OFFERING MATERIALS, THE WORDS “ESTIMATE,” “PROJECT,” “BELIEVE,” “ANTICIPATE,” “INTEND,” “EXPECT” AND SIMILAR EXPRESSIONS ARE INTENDED TO IDENTIFY FORWARD-LOOKING STATEMENTS, WHICH CONSTITUTE FORWARD LOOKING STATEMENTS. THESE STATEMENTS REFLECT MANAGEMENT’S CURRENT VIEWS WITH RESPECT TO FUTURE EVENTS AND ARE SUBJECT TO RISKS AND UNCERTAINTIES THAT COULD CAUSE THE COMPANY’S ACTUAL RESULTS TO DIFFER MATERIALLY FROM THOSE CONTAINED IN THE FORWARD-LOOKING STATEMENTS. INVESTORS ARE CAUTIONED NOT TO PLACE UNDUE RELIANCE ON THESE FORWARD-LOOKING STATEMENTS, WHICH SPEAK ONLY AS OF THE DATE ON WHICH THEY ARE MADE. THE COMPANY DOES NOT UNDERTAKE ANY OBLIGATION TO REVISE OR UPDATE THESE FORWARD-LOOKING STATEMENTS TO REFLECT EVENTS OR CIRCUMSTANCES AFTER SUCH DATE OR TO REFLECT THE OCCURRENCE OF UNANTICIPATED EVENTS.
              <br><br>
				AN OFFERING STATEMENT REGARDING THIS OFFERING HAS BEEN FILED WITH THE SEC. THE SEC HAS QUALIFIED THAT OFFERING STATEMENT, WHICH ONLY MEANS THAT THE COMPANY MAY MAKE SALES OF THE SECURITIES DESCRIBED BY THE OFFERING STATEMENT. IT DOES NOT MEAN THAT THE SEC HAS APPROVED, PASSED UPON THE MERITS OR PASSED UPON THE ACCURACY OR COMPLETENESS OF THE INFORMATION IN THE OFFERING STATEMENT. YOU MAY OBTAIN A COPY OF THE OFFERING CIRCULAR THAT IS PART OF THAT OFFERING STATEMENT FROM:
              <br><br>
				<a class="external-link" target="_blank" href="GST_offering_circular.pdf">https://geosolar-technologies-inc.microcaps.com/GST_offering_circular.pdf</a>
              <br><br>
        "All shares purchased will be held for safekeeping in the investors' name at Empire Stock Transfer.” (<a href="http://empirestock.com/" class="external-link" target="_blank">empirestock.com</a>)
              <br><br>
				YOU SHOULD READ THE OFFERING CIRCULAR BEFORE MAKING ANY INVESTMENT.
              <br><br>
				<b>GeoSolar Technologies Inc. (Reg A Offering) </b>Manhattan Street Capital is compensated by GeoSolar Technologies Inc.  for project management ($5,000 per month), listing the offering of the issuer’s securities ($2,500 per month), and technology administration ($25 per investment). MSC might earn up to an estimated maximum amount of $462,500.00 on this offering. Further to this, MSC holds a 2% equity stake in GeoSolar Technologies Inc. of February 15, 2022, with a potentially unlimited upside.
            </p>
          </transition>
        </div>
        
      </div>
  </section>
</template>

<script>
export default {
  name: 'Disclaimer',
  data () {
    return {
      disclaimer: true
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/disclaimer.scss";
</style>

